import { Checkbox, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSalespersonReassignmentProfile extends Layout {
    checkboxActivityReset: Checkbox;
    checkboxCcFrmrSalesmgr: Checkbox;
    checkboxCcFrmrSalesperson: Checkbox;
    checkboxCcSalesmgr: Checkbox;
    panelLeft: Panel;
    panelRight: Panel;
    sourceSalespersonReassign: DataSource;
    textboxActivityCount: Textbox;
    textboxActivityDays: Textbox;
    textboxDateType: Textbox;
    textboxDescr: Textbox;
    textboxEmail: Textbox;
    textboxId: Textbox;
    textboxOrderCount: Textbox;
    textboxOrderDays: Textbox;
    textboxRevenue: Textbox;
    textboxRevenueDays: Textbox;
    textboxSalespersonId: Textbox;
}
